module.exports = __webpack_public_path__ + "static/media/khu.92c9aeb3.ogg";